import { CATEGORIES_ID, VARIANTS_ATTR_EMBARGO_EXTR_RELEASED, VARIANTS_PRICES_DISCOUNT, } from '@yme/common/constants';
import { getFacetsLabel } from '../common/helpers';
// Prepared Pills data
export function getPillsOptions(selectedFacets, dictionary, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
handleUpdateFacets, fallBackFacetsData) {
    const splittedSelectedFacets = selectedFacets.split('|');
    return splittedSelectedFacets.map((item) => {
        const [key, values] = item.split(':');
        const valuesArray = values.split(',').map((item) => {
            const itemKey = item.replace('"', '').replace('"', '').trim();
            if (key === CATEGORIES_ID) {
                const categoryIdValues = (fallBackFacetsData &&
                    fallBackFacetsData.find((i) => i.id === key)?.values) ||
                    [];
                const currentFacet = categoryIdValues?.length &&
                    categoryIdValues.find((i) => i.value === itemKey);
                return (currentFacet && currentFacet?.name) || itemKey;
            }
            return itemKey;
        });
        const finallyValue = valuesArray.length <= 2
            ? valuesArray.slice(0, 2).join(', ')
            : `${valuesArray.slice(0, 2).join(', ')}... +${valuesArray.slice(2).length}`;
        const result = {
            groupId: key,
            label: getFacetsLabel({
                fullBackValue: key,
                key,
                dictionary,
            }),
            value: finallyValue,
            fullToolTipLabel: valuesArray.length > 2 ? valuesArray.join(', ') : undefined,
            handleDelete: () => handleUpdateFacets(key),
        };
        return result;
    });
}
export function getPreparedData({ isShowOnlyDiscounted, isCompatibleProductChecked, compatibleProductKey, isInAuthor, }) {
    const discountedProducts = isShowOnlyDiscounted ? [VARIANTS_PRICES_DISCOUNT] : [];
    const compatibleProductQueryParam = isCompatibleProductChecked
        ? [`variants.attributes.products:${compatibleProductKey}`]
        : [];
    const extraQueryParam = [
        isInAuthor ? '' : VARIANTS_ATTR_EMBARGO_EXTR_RELEASED,
        ...discountedProducts,
        ...compatibleProductQueryParam,
    ].filter(Boolean);
    return {
        extraQueryParam,
    };
}
